export const CHANGE_GRAYLIST_STATUS = "CHANGE_GRAYLIST_STATUS"

export const GET_USERS_GRAYLIST = "GET_USERS_GRAYLIST"
export const SET_USERS_GRAYLIST = "SET_USERS_GRAYLIST"

export const GET_GRAYLIST_ZIPCODE = "GET_GRAYLIST_ZIPCODE"
export const SET_GRAYLIST_ZIPCODE = "SET_GRAYLIST_ZIPCODE"
